import { AUTH_PERMISSION_ROLES } from '../Constants';

const userPermissionsByRole = (permissionRoles) => {
    const initialObject = {
        isContentReviewer: false,
        isContentAuthor: false,
        isContentAdmin: false,
        isTeamAdmin: false,
        isAccountOwner: false,
        isVerbAdmin: false,
        isTeamReportViewer: false,
        isCompanyReportViewer: false,
        isVerbReportViewer: false,
        isInstructionalAdmin: false,
        isInstructionalContentAdmin: false,
        isInstructionalReportViewer: false
    };

    if (!Array.isArray(permissionRoles)) {
        return initialObject;
    }

    permissionRoles.forEach((roleObject) => {
        const { role } = roleObject;
        if (role === 'ReportViewer') {
            initialObject.isCompanyReportViewer = true;
        } else if (role) {
            initialObject[AUTH_PERMISSION_ROLES[role]] = true;
        }
    });
    return initialObject;
};

const userPermissionRoles = (permissionRoles) => {
    const initialObject = {
        ContentReviewer: false,
        ContentAuthor: false,
        ContentAdmin: false,
        TeamAdmin: false,
        AccountOwner: false,
        VerbAdmin: false,
        TeamReportViewer: false,
        CompanyReportViewer: false,
        VerbReportViewer: false,
        ReportViewer: false,
        InstructionalAdmin: false,
        InstructionalContentAdmin: false,
        InstructionalReportViewer: false
    };

    if (!Array.isArray(permissionRoles)) {
        return initialObject;
    }

    permissionRoles.forEach((roleObject) => {
        const { role } = roleObject;
        if (role) initialObject[role] = true;
    });

    return initialObject;
};

export { userPermissionsByRole, userPermissionRoles };
